function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40",
  fill: "none",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  stroke: "currentColor",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M18.12 22.16a18.82 18.82 0 005.88 4.3l2-1.95a4.3 4.3 0 01.75-.59 1.37 1.37 0 011.25-.08l4.19 2a3.07 3.07 0 01-.65 4.08 8 8 0 01-5 2.19s-5-.83-11.29-7.14-7.07-11.3-7.07-11.3a8 8 0 012.19-5 3.07 3.07 0 014.08-.64l2 4.18a1.37 1.37 0 01-.07 1.33 4.93 4.93 0 01-.6.75l-1.94 1.95a18.65 18.65 0 004.28 5.92zm9.94-11.75l-6.69 7m-.08 0l-.09-4.19m.25 4.19l4.2-.1"
}));